import React from 'react';
import createPlotlyComponent from 'react-plotlyjs';
import Plotly from 'plotly.js/dist/plotly-cartesian';
import PropTypes from 'prop-types';


function DonutChart({ title, name, values, labels }) {
    const PlotlyComponent = createPlotlyComponent(Plotly);
    const data = [
        {
            values,
            labels,
            name,
            hoverinfo: 'label+percent',
            hole: .4,
            type: 'pie',
            marker: {
                colors: ['#8FDB00', '#763DFF']
            }
        }
    ]

    const layout = {
        title,
        annotations: [
            {
                font: {
                    size: 20
                },
                showarrow: false,
                text: name
            }
        ],
        height: 400,
        width: 400,
        showlegend: false
    }

    const config = {
        showlink: false,
        displaylogo: false
    }

    return (
        <PlotlyComponent data={data} layout={layout} config={config}/>
    )
}
DonutChart.propTypes = {
    title:PropTypes.string,
    name:PropTypes.string,
    values:PropTypes.array,
    labels:PropTypes.array
};

export default DonutChart;